import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { acGetReceivingSites } from "state/receiving-sites/actions";

const useReceivingSites = () => {
  const dispatch = useDispatch();
  const { all, active, inactive, ref, pending, touched } = useSelector(
    (state) => state.receivingSites
  );

  useEffect(() => {
    if (!touched) dispatch(acGetReceivingSites);
  }, [dispatch, touched]);

  return { pending, touched, all, active, inactive, ref };
};

export default useReceivingSites;
